export const BASE = 'base';
